import React from 'react';
import styled from '@emotion/styled';
import {
  Divider,
  Typography,
} from '@mui/material';
import { useAppSelector } from '@/redux/hooks';
import { selectInventorySelections } from '@/redux/selectors/orderPlacementSelectors';
import FileSelectContents from '@/components/TitleDetail/FileSelect/FileSelectContents';

const SelectedFilesSidebar = () => {
  const files = useAppSelector(selectInventorySelections);

  return (
    <Wrapper>
      <div style={{ position: 'sticky', top: 0, zIndex: 1, background: 'inherit' }}>
        <ColumnHeader>
          <Typography variant="h5" fontWeight={'bold'}>
            Selected Files
          </Typography>
        </ColumnHeader>
        <ResultsCount>
          {`${files.length} files`}
        </ResultsCount>
      </div>
      <ScrollableDiv>
        <Divider sx={{ width: '100%', margin: '8px 0' }} />
        <FileSelectContents fullWidth noVideo />
      </ScrollableDiv>
    </Wrapper>
  );
};

export default SelectedFilesSidebar;

const Wrapper = styled.div`
  width: 318px;
  min-width: 318px;
  background: ${({ theme }) => theme.palette.background.paper};
  padding: ${({ theme }) => theme.spacing(3)};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

const ScrollableDiv = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  flex-grow: 1;
  width: 100%;
  display: block;
`;

const ColumnHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: ${({ theme }) => theme.spacing(2)};
`;

const ResultsCount = styled.div`
  padding: ${({ theme }) => theme.spacing(1, 0)};
  font-size: 1.2rem;
  font-weight: 200;
  opacity: 0.4;
`;